var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    [
      _vm.formState === "default"
        ? _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", [
                _c("div", { staticClass: "forgotten-password" }, [
                  _vm._v(_vm._s(_vm.$t("auth.forgotten-password-title"))),
                ]),
              ]),
              _c("v-card-subtitle", [
                _c("div", { staticClass: "password-reset-description" }, [
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("auth.password-description"))),
                ]),
              ]),
              _c(
                "v-card-text",
                { staticStyle: { padding: "0" } },
                [
                  _c("br"),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "", justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "10" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              color: "primary",
                              outlined: "",
                              "prepend-icon": "mdi-account",
                              name: "Username",
                              label: _vm.$t("auth.email-address"),
                              placeholder: " ",
                            },
                            model: {
                              value: _vm.form.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "username", $$v)
                              },
                              expression: "form.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        loading: _vm.loading,
                        disabled: _vm.loading,
                        color: "primary",
                      },
                      on: { click: _vm.forgotPassword },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.send")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.formState === "forgot"
        ? _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", { attrs: { "primary-title": "" } }, [
                _c("div", { staticClass: "forgotten-password" }, [
                  _vm._v(_vm._s(_vm.$t("auth.password_recovery"))),
                ]),
              ]),
              _c(
                "v-card-text",
                { staticStyle: { padding: "0" } },
                [
                  _c("br"),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "", justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "10" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              name: "Code",
                              label: _vm.$t("auth.Code"),
                              placeholder: " ",
                            },
                            model: {
                              value: _vm.form.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "code", $$v)
                              },
                              expression: "form.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "", justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "10" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              name: "New Password",
                              label: _vm.$t("auth.new_password"),
                              placeholder: " ",
                              type: "password",
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        loading: _vm.loading,
                        disabled: _vm.loading,
                        color: "primary",
                      },
                      on: { click: _vm.confirmPassword },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.errorExists
        ? _c(
            "v-snackbar",
            {
              attrs: {
                bottom: "",
                right: "",
                shaped: "",
                value: _vm.errorExists,
                color: "secondary",
              },
            },
            [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }